import {React, useContext} from 'react'
import bg_img3 from './static/img/bg-img3.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurServicesSection from './OurServicesSection'
import FeedbackSection from './FeedbackSection'
import RoutesContext from '../contexts/RoutesContext'

function Service1Page(props) {
    let routes_context = useContext(RoutesContext);
  return (
    <main onLoad={routes_context.flip_card_resize}>
        
        <BreadcrumbsSection routes={routes_context.routes} page_name='Services' />
        <div className="services_banner_section">
            <div className="services_banner_inner_wrapper">
                <img src={bg_img3} alt="" />
            </div>
        </div>

        <OurServicesSection routes={routes_context.routes} setCurrentPage = {routes_context.setCurrentPage} />

        <div className="content_section" id="content_section">
            <div className="content_inner_wrapper">
                <h1 className="service_content_title">ENTERPRISE ECOLOGICAL PASSPORT</h1>
                <p>
                    Guramanyň ýolbaşçysy tarapyndan tassyklanýan hem-de tebigy baýlyklaryň, ikinji gezek ulanylýan we beýleki serişdeleriň (resurslaryň) peýdalanylyşy baradaky maglumatlary beýan edýän we şol kärhananyň işiniň (galyndylaryň daşyna çykarylmagynyň, galyndylaryň ulanylmagynyň we beýleki ýagdaýlaryň) daşky gurşawa ýetirýän täsirini kesgitleýän ýerli (lokal) hukuknamasy.
                </p>
                <br/><br/>
                <h2>ENTERPRISE ECOLOGICAL PASSPORT NÄME, OL KIME WE NÄME ÜÇIN GEREK?</h2>
                <p>
                    Munuň özi kärhanada ulanylýan serişdeleriň (resurslaryň) ählisi hem-de daşky gurşawa ýetirilýän täsiriň ähli görnüşleri barada doly maglumat berýän kadalaşdyryjy-tehniki resminamadyr. Edaranyň işiniň tehnologik shemasy baradaky maglumatdan başga-da, pasportda şular görkezilýär:
                </p>
                <p>— Daşyna çykarylýan we atmosferany hapalaýan galyndylaryň hiliniň we mukdarynyň häsiýetnamalary;</p>
                <p>— Edaranyň howdanlara we topraga arassalanan we arassalanmadyk ýagdaýda akdyrýan suwlary;</p>
                <p>— Önümçiligiň emele gelýän we ýerleşdirilýän howply galyndylary.</p>
                <p>
                    Şeýle hem resminamada senagat işleriniň daşky gurşawa ýetirýän zeleliniň azaldylmagyna gönükdirilen çäreleriň jikme-jik düzülen sanawy we bu çäreleri amala aşyrmagyň anyk möhletleri hem-de bulary berjaý etmek üçin çykarylýan harajatlaryň jemi görkezilýär.
                </p>
                <br/><br/>
                <h2>EKOLOGIK PASPORTY IŞLENIP DÜZÜLENDE NÄME GÖZ ÖŇÜNDE TUTULÝAR.</h2>
                <p>ENTERPRISE ECOLOGICAL PASSPORT nyň kanunçylygyň kadalaryna laýyklykda nädip düzülýändigini bilmek üçin, oňa haýsy bölümleriň goşulýandygyna düşünmek gerek:</p>
                <p>— Umumy maglumatlar – edara görnüşli tarapyň ady, ýerli (lokal) monitoring we beýlekiler;</p>
                <p>— Eýelik edýäniň önümçilik häsiýetnamalary – işlenip çykarylýan önümiň möçberi, çig malyň we energetiki resurslaryň sarp edilişi, ozony bozýan maddalaryň çykyşy;</p>
                <p>— Atmosferadaky howany goramak – daşyna çykarmak üçin rugsat alyndymy, hapalaýan stasionar çeşmeleriň oturdylmagy;</p>
                <p>— Ýer resurslary – kärhananyň eýelik edýän ýa-da kärendesine alnan meýdançalary, bagy-bossanly giňişlikler barmy;</p>
                <p>— Suwdan peýdalanmak we suwy akdyrmak (suwy sowmak) – hukuklary kesgitleýän resminamalar, akymlaryň möçberleri we akymlaryň arassalanylyşy baradaky maglumat;</p>
                <p>— Önümçiligiň galyndylary – galyndylary saklamak we düzümlere bölmek, ýok etmek;</p>
                <p>— Kärhananyň ulaglary – ulag serişdeleriniň hem-de ulanylýan ýangyjyň görnüşleri;</p>
                <p>— Kartografik materiallar.</p>
                <br/><br/>
                <h2>KANUNÇYLYGYŇ KADALARY</h2>
                <p>
                    Ekologik pasport <b>TDS 17.0.0.04-90 “ENTERPRISE ECOLOGICAL PASSPORT. Esasy düzgünler”</b><br/>
                    boýunça bildirilýän talaplara laýyklykda işlenip düzülmelidir. Ykdysady görkezijiler, ştatyň möçberi ýa-da salgyt salmagyň ulgamy resminamanyň bozulmagyna öz täsirini ýetirmeli däldir. Ekologik pasport bölümler üçin özbaşdak görnüşde däl-de, edara boýunça umumy görnüşde taýýarlanýar. Ýolbaşçy çözgüdi özbaşdak kabul edýär. Eýelik edýän çalşan halatynda, öňki ekologik pasporty saklap galmak gerek, eger bina kärendesine alnan bolsa, täze resminamany işläp düzmek talap edilýär.
                </p>
                <br/><br/>
                <h2 className="service_content_footer">AŞAKDA GÖRKEZILEN GÖRNÜŞDÄKI TALAPNAMANY TABŞYRYŇ ÝA-DA BIZE JAŇ EDIŇ.</h2>
            </div>
        </div>

        <FeedbackSection margin_top="margin_top" />    

    </main>
  )
}

export default Service1Page